import React from 'react';

import { Divider } from 'redpoints-front-components/index';
import { LinkSellerForm } from 'redpoints-front-common/components';

import { translate } from '../../../helpers/languageHelper';

const IncidentDetailsSeller = ({
  editable,
  forceValidation,
  sellerData,
  sellerLinkDataChange,
  sellerLinkDataValidate,
  sellerLinkMetadata,
}) => (
  <>
    <Divider />
    <h3>{translate('reporting.incidentDetails.seller.title')}</h3>
    <LinkSellerForm
      editable={editable}
      forceValidation={forceValidation}
      linkMetadata={sellerLinkMetadata}
      onChange={sellerLinkDataChange}
      onValidate={sellerLinkDataValidate}
      sellerData={sellerData}
      shouldIgnoreMandatoryValidation
    />
  </>
);

export default IncidentDetailsSeller;
